import { Box, LinearProgress, ModalProps, Typography } from '@mui/material';
import { BasicModal, CustomDropzone } from '../common';

interface AccidentAddDocumentModalProps extends Omit<ModalProps, 'children' | 'open'> {
  title?: string;
  name?: string;
  limit?: number;
  accidentId?: string;
  onUpload?: (file: File[], name: string) => void;
  isUploading?: boolean;
}

export const AccidentAddDocumentModal = ({
  onClose,
  title,
  limit,
  name,
  accidentId,
  onUpload,
  isUploading,
  ...props
}: AccidentAddDocumentModalProps) => (
  <BasicModal open={!!title} onClose={onClose} {...props}>
    <>
      <Typography variant="h6">{title}</Typography>
      <Box mt={2}>
        {isUploading ? (
          <LinearProgress />
        ) : (
          <CustomDropzone
            onLoadedFiles={(files) => onUpload?.(files, name as string)}
            accept={{
              'image/png': ['.png'],
              'image/jpeg': ['.jpg', '.jpeg'],
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
              'application/msword': ['.doc'],
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
              'application/vnd.ms-excel': ['.xls'],
              'application/pdf': ['.pdf'],
              'application/vnd.ms-outlook': ['.msg']
            }}
          />
        )}
      </Box>
    </>
  </BasicModal>
);
